import { whenGt } from '@execonline-inc/numbers';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import ActivationsRemaining from './ActivationsRemaining';
import NoActivations from './NoActivations';

export interface Props {
  activationsRemaining: Maybe<number>;
  title: string;
  newLicenseAllocations: number;
  allocatedLicenses: number;
}

function Lima({ activationsRemaining, title, newLicenseAllocations, allocatedLicenses }: Props) {
  return activationsRemaining
    .andThen(whenGt(0))
    .map((ar) => (
      <ActivationsRemaining
        activationsRemaining={ar}
        publicName={title}
        newLicenseAllocations={newLicenseAllocations}
        allocatedLicenses={allocatedLicenses}
      />
    ))
    .getOrElse(() => <NoActivations productLicenseTitle={title} />);
}

export default observer(Lima);
